import { Key, getLocalStorage, setLocalStorage } from './localStorage'

/*
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-07 17:30:11
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-02-18 18:46:36
 * @FilePath: /lobby/src/common/config.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
export const config = {
  resBaseUrl: import.meta.env.VITE_RES_BASE_URL, //'https://res.megalake.games/lobby/',
  hideHeaderPages: ['bonus'],
  hideFooterPages: ['bonus'],
  selfDevelopedGameDomain: import.meta.env.VITE_SELF_GAME_DOMAIN,
  pp_game_ws: import.meta.env.VITE_PP_GAME_WS, //游戏ws地址
  env: import.meta.env.VITE_APP_ENV, //环境
}

export const url = {
  game: {
    categories: '/game/categories',
    list: '/game/list',
    enter: '/game/url',
    favorite: '/game/collect',
    records: '/wallet/records'
  },
  lobby: {
    banners: '/lobby/banners',
    batchBanners: '/lobby/batchBanners', //获取国家多个位置的Banner
    promotionsBanners: '/lobby/promotionsBanners' //获取国家Promotions的Banner
  },
  ping: '/ping',
  user: {
    balance: '/wallet/balance',
    getUserInfo: '/user/getUserInfo',
    login: '/user/login',
    logout: '/user/logout',
    register: '/user/register',
    sms: '/captcha/sms',
    usernameSms: '/captcha/usernameSms',
    bindPhone: '/user/bindPhone',
    restPwd: '/user/resetPwd',
    checkBindViaUser: '/user/checkBindViaUser',
    changePassWord: '/user/changePwd',
    usc: '/recharge/usc' //查询用户充值次数
  },
  recharge: {
    create: '/recharge/createRechargeOrder',
    config: '/recharge/getRecommendConfigs',
    prepay: '/recharge/prepay',
    querypay: '/recharge/queryPay',
    orders: '/recharge/orders',
    depositActivity: '/recharge/depositActivity', // 查询充值活动（充值页面使用接口）
    paymentMethods: '/recharge/paymentMethods' //获取充值支付方式配置
  },
  withdraw: {
    create: '/withdraw/create',
    orders: '/withdraw/orders',
    paymentMethods: '/withdraw/paymentMethods', //获取提现支付方式配置
    fetchTaxExemptAmount: '/withdraw/fetchTaxExemptAmount' //查询用户免税额度
  },
  notice: {
    list: '/notice/list'
  },
  bonus: {
    config: '/bonus/config',
    exchange: '/bonus/exchange',
    orders: '/bonus/orders',
    records: '/wallet/bonus/collect/records',
    ncf: '/bonus/ncf'
  },
  redpackage: {
    claimed: '/lucky/money/claimed', //获取提现成功列表
    collected: '/lucky/money/collected', // 获取红包助力列表
    create: '/lucky/money/create', // 创建一个红包
    envelope: '/lucky/money/envelope', // 获取有效的红包
    share: '/lucky/money/share', //  分享红包
    claim: '/lucky/money/claim', // 领取红包
    domain: '/lucky/money/domain', //获取分享链接
    guide: '/lucky/money/guide', //获取新手引导状态
    finishGuide: '/lucky/money/finishGuide', // 完成新手引导
    latestCollected: '/lucky/money/latestCollected', //获取红包最新助力列表
    displayReward: '/lucky/money/displayReward', //获取展示红包领取奖励额度
    totalClaimedReward: '/lucky/money/totalClaimedReward' //获取已领取红包奖励总额
  },
  popup: '/lobby/popups', // 获取PopUp
  cashback: {
    load: '/v1/pig/load',
    collect: '/v1/pig/collect',
    record: '/v1/pig/record',
    marquee: '/v1/pig/marquee'
  },
  VpsExchange: {
    list: '/v1/mall/list',
    buy: '/v1/mall/buy',
    marquee: '/v1/mall/marquee',
    record: '/v1/mall/record'
  },
  dailyTask: {
    list: '/v1/task/every/list',
    buy: '/v1/task/every/take'
  },
  Million: {
    spin: '/v1/big/spin',
    global: '/v1/big/global',
    cost: '/v1/big/cost',
    myCode: '/v1/big/code',
    rewards: '/v1/big/rewards',
    history: '/v1/big/history',
    record: '/v1/big/record'
  },
  event: {
    limited: {
      time: {
        recharge: {
          claim: '/event/limited/time/recharge/claim', // 领取累积充值奖励
          get: '/event/limited/time/recharge/get' // 获取累积充值信息
        }
      }
    }
  }
}

export function defaultCountry() {
  const localCountry = getLocalStorage(Key.Country)
  if (localCountry) return localCountry
  const hostname = window.location.hostname
  let country = window.country || 'ET'
  switch (hostname) {
    case 'lobby.megalake.games':
    case 'www.vivagame.et':
    case 'www.vivabet.et':
    case 'vivagame.et':
    case 'vivabet.et':
      country = 'ET'
      break
    case 'lobby-ci.megalake.games':
    case 'www.vivagame.africa':
    case 'vivagame.africa':
    case 'www.vivagame.ci':
    case 'vivagame.ci':
      country = 'CI'
      break
    case 'lobby-ke.megalake.games':
    case 'www.vivagame.ke':
    case 'www.vivabet.ke':
    case 'www.vivagame.co.ke':
    case 'vivagame.co.ke':
    case 'vivagame.ke':
    case 'vivabet.ke':
      country = 'KE'
      break
    case 'www.vivagame.co.tz':
    case 'vivagame.co.tz':
      // case 'lobby.megalake.games':
      country = 'TZ'
      break
    case 'www.bigwins.com.gh':
      country = 'GH'
      break
    default:
      break
  }
  console.log('defaultCountry: =====>>>>>', country)
  // setLocalStorage(Key.Country, country)
  return country
}

export function defaultLanguage() {
  const localLanguage = getLocalStorage(Key.Locale)
  if (localLanguage) return localLanguage
  let languageu = 'en'
  switch (defaultCountry()) {
    case 'ET':
      languageu = localLanguage && localLanguage != 'fr' ? localLanguage : 'en'
      break
    case 'CI':
      languageu = 'fr'
      break
    case 'KE':
      languageu = 'en'
      break
    case 'TZ':
      languageu = 'sw'
      break
    default:
      break
  }
  console.log('defaultLanguage: =====>>>>>', languageu)
  setLocalStorage(Key.Locale, languageu)
  return languageu
}

export const WEBSITE_ID = 'b99fa5ac-3540-4885-9922-0a7f03b5f380'
export const AIRBRIDEG = {
  WEB_TOKEN: 'e507e991005a464c83abee748a0ad01b',
  APP_NAME: {
    ['www.vivagame.et']: 'vivagameet',
    ['vivagame.et']: 'vivagameet'
  },
  API_TOKEN: 'e6978017134f47ea97d702d0da486219', // api token
  BET_LINKS_API_TOKEN: 'ef4ef45ac8174363b5714a57fae24200' //追踪链接api token
}
